import { getSnapMenuLineItem } from 'containers/Snaps/Snap/lib';

import { ProductLineItemMatch } from 'codegen';

export const getFormattedMatchedProductItem = (item: ProductLineItemMatch) => ({
  ...item,
  lineItem: {
    ...item.lineItem,
    ...getSnapMenuLineItem(item.lineItem),
  },
  matchedProduct: {
    ...item.matchedProduct,
    value: item.matchedProduct?.id,
    label: item.matchedProduct?.productName,
  },
  matchedBy: {
    ...item.matchedBy,
    value: item.matchedBy?.id,
    label: `${item.matchedBy?.type} ${item.matchedBy?.value}`,
  },
  matchedByIdentities: item.matchedByIdentities?.map((identity) => ({
    ...identity,
    value: identity.id,
    label: `${identity.type} ${identity.value}`,
  })),
}) as ProductLineItemMatch;
